# Define boundaries here. Properties:
#
# -- IDENTITY --
# id         id used in street data
# label      label to display (English fallback)
# spriteId   sprite id prefix, should append `-left` or `-right` to this unless
#            `sameOnBothSides` is true
#
# -- CHARACTERISTICS --
# hasFloors        (boolean) true if building can have multiple floors
# sameOnBothSides  (boolean) true if the same sprite is used both sides of the street
# repeatHalf       (boolean) true if half of the sprite is repeating and the other half anchors to street edge
#                            todo: better property name
# alignAtBaseline  (boolean) true if bottom of sprite should be anchored at baseline rather than ground plane
#
# -- SPECIFICATIONS --
# variantsCount    (number) actually, not sure
#                            guess: it varies the upper floor designs
# mainFloorHeight  (number) in meters, how tall is the ground floor
#                            todo: use pixel heights for these?
# floorHeight      (number) in meters, how tall are intermediate floors (which can repeat)
# roofHeight       (number) in meters, how tall is the roof structure
# overhangWidth    (number) in CSS pixels, amount to overhang the sidewalk (adjusts OVERHANG_WIDTH)
grass:
  id: grass
  label: Grass
  spriteId: boundaries--grass
  hasFloors: false
  sameOnBothSides: true
fence:
  id: fence
  label: Empty lot
  spriteId: boundaries--fenced-lot
  hasFloors: false
parking-lot:
  id: parking-lot
  label: Parking lot
  spriteId: boundaries--parking-lot
  hasFloors: false
  repeatHalf: true
  offsetY: 0.15 # meters
waterfront:
  id: waterfront
  label: Waterfront
  spriteId: boundaries--waterfront
  hasFloors: false
  alignAtBaseline: true
  repeatHalf: true
residential:
  id: residential
  label: Home
  spriteId: buildings--residential
  hasFloors: true
  variantsCount: 0
  floorHeight: 3 # meters (match illustration)
  roofHeight: 2 # meters (match illustration)
  mainFloorHeight: 7.25 # meters (match illustration)
narrow:
  id: narrow
  label: Building
  spriteId: buildings--apartments-narrow
  hasFloors: true
  variantsCount: 1
  floorHeight: 3 # meters (match illustration)
  roofHeight: 0.7 # meters (match illustration)
  mainFloorHeight: 4.1 # meters (match illustration)
  overhangWidth: 16
wide:
  id: wide
  label: Building
  spriteId: buildings--apartments-wide
  hasFloors: true
  variantsCount: 1
  floorHeight: 3 # meters (match illustration)
  roofHeight: 0.7 # meters (match illustration)
  mainFloorHeight: 4.1 # meters (match illustration)
  overhangWidth: 21.5 # pixels
arcade:
  id: arcade
  label: Arcade building
  spriteId: buildings--arcade
  hasFloors: true
  variantsCount: 1
  floorHeight: 3.1 # meters (match illustration)
  roofHeight: 1.8 # meters (match illustration)
  mainFloorHeight: 4.1 # meters (match illustration)
  overhangWidth: 15 # pixels
compound-wall:
  id: compound-wall
  label: Compound wall
  spriteId: boundaries--compound-wall
  hasFloors: false
beach:
  id: beach
  label: Beach
  spriteId: boundaries--beach
  hasFloors: false
  alignAtBaseline: true
  repeatHalf: true
  earthColor: "#ecdbb1"
marsh:
  id: marsh
  label: Marsh
  spriteId: boundaries--marsh
  hasFloors: false
  alignAtBaseline: true
  repeatHalf: true
  earthColor: "#ecdbb1"
water:
  id: water
  label: Water
  spriteId: boundaries--water
  hasFloors: false
  alignAtBaseline: true
  repeatHalf: true
  earthColor: "#366387"
dock:
  id: dock
  label: Dock
  spriteId: boundaries--dock
  hasFloors: true
  variantsCount: 1 # need this to be 1 to do a thing right
  floorHeight: 0.25 # meters (match illustration)
  roofHeight: 3 # meters (match illustration)
  mainFloorHeight: 1.75 # meters (match illustration)
  alignAtBaseline: true
  repeatHalf: true
  earthColor: "#366387"
